import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCircle,
  SkeletonCard,
  SkeletonListItem,
} from '@/components/common/skeleton';

const KPI_TILE_COUNT = 4;

export const ResidentDetailsSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {/* Header: avatar + name + property */}
    <View style={styles.header}>
      <SkeletonCircle size={64} />
      <View style={styles.headerText}>
        <SkeletonBone width={200} height={22} />
        <SkeletonBone width={140} height={14} />
      </View>
    </View>

    {/* KPI summary bar — 4 tiles in a row */}
    <View style={styles.kpiRow}>
      {Array.from({ length: KPI_TILE_COUNT }).map((_, i) => (
        <View key={i} style={styles.kpiTile}>
          <SkeletonBone width={60} height={11} />
          <SkeletonBone width={80} height={22} />
          <SkeletonBone width={70} height={12} />
        </View>
      ))}
    </View>

    {/* Tab bar */}
    <SkeletonBone width="100%" height={38} borderRadius={8} />

    {/* Overview body */}
    <SkeletonCard>
      <SkeletonListItem avatar={false} lines={2} lineWidths={['80%', '60%']} />
      <SkeletonListItem avatar={false} lines={2} lineWidths={['70%', '50%']} />
      <SkeletonListItem avatar={false} lines={2} lineWidths={['85%', '55%']} />
    </SkeletonCard>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingTop: 12,
    gap: 16,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 14,
  },
  headerText: {
    flex: 1,
    gap: 8,
  },
  kpiRow: {
    flexDirection: 'row',
    gap: 8,
  },
  kpiTile: {
    flex: 1,
    gap: 6,
  },
});
